var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vertical-line bg-color-dark",attrs:{"id":"app"}},[_vm._l((9),function(i){return _c('div',{key:i,staticClass:"grid"})}),_c('router-view')],2)}
var staticRenderFns = []

export { render, staticRenderFns }